import { FullCenteredMain } from '@/layouts/FullCenteredLayout.tsx'
import LoadingCard from '@/common/components/LoadingCard.tsx'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { getTransferScholarStatus } from '@/apis/v1_renewal_bridge/transfer_scholars.ts'
import { useAppAlert } from '@/app/AppAlertProvider.tsx'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import { CheckEmail } from '@/app/pages/authentication/CheckEmail.tsx'
import { Card, CardContent } from '@/common/components/Card.tsx'
import { resendTransferScholarEmailInvitation } from '@/apis/v1_renewal_bridge/transfer_scholars'

export default function V1toV2BridgePage() {
  const { t: translate } = useTranslation()
  const [searchParams] = useSearchParams()
  const [requestPending, setRequestPending] = useState<boolean>(false)
  const navigateTo = useNavigate()
  const { fireAlert } = useAppAlert()
  const [applicantNotFound, setApplicantNotFound] = useState<boolean>(true)
  const [applicantEmail, setApplicantEmail] = useState<string>('')

  useEffect(() => {
    const externalApplicantId = searchParams.get('external_applicant_id')
    if (externalApplicantId !== null) {
      setRequestPending(true)
      ;(async function () {
        const callBackUrl =
          window.location.origin + AppRoutePaths.auth.registration_invite
        const response = await getTransferScholarStatus(
          externalApplicantId,
          searchParams.get('simulate') == 'true',
          callBackUrl
        )
        if (response.error !== null) {
          await fireAlert({
            variant: 'error',
            message: response.error.message,
          })
          navigateTo(AppRoutePaths.auth.login)
          return
        }

        if (response.data.transfer_status == 'incomplete') {
          setApplicantEmail(response.data.email)
          setApplicantNotFound(true)
        } else {
          await fireAlert({
            variant: 'success',
            message: translate('account_transferred_log_in'),
          })
          navigateTo(AppRoutePaths.auth.login)
        }

        setRequestPending(false)
      })()
    }
  }, [])

  const handleResend = async () => {
    const externalApplicantId = searchParams.get('external_applicant_id')
    if(!externalApplicantId)return
    const callBackUrl =
      window.location.origin +
      AppRoutePaths.auth.registration_invite
    const response = await resendTransferScholarEmailInvitation(
      externalApplicantId,
      callBackUrl
    )
    if (response?.error) {
      await fireAlert({
        variant: 'error',
        message: response.error?.message ?? "",
      })
      return
    }
    await fireAlert({
      variant: 'success',
      message: response?.data?.msg ?? "",
    })
  }

  if (applicantNotFound && applicantEmail) {
    return (
      <FullCenteredMain>
        <Card>
          <CardContent>
            <CheckEmail onResend={handleResend}>
              <CheckEmail.Instructions className="mb-12">
                {translate('please_verify_your_email_by_clicking')}{' '}<br/>
                <span className="text-gray-700 font-medium">
                  {applicantEmail}
                </span>
              </CheckEmail.Instructions>
            </CheckEmail>
          </CardContent>
        </Card>
      </FullCenteredMain>
    )
  }

  return (
    <FullCenteredMain>
      <LoadingCard isLoading={requestPending}>
        <h1>{translate('setting_things_up_prompt')}</h1>
      </LoadingCard>
    </FullCenteredMain>
  )
}
